function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import map from 'lodash/map';
import { AppContext } from 'context';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import App from 'modules/App';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import styles from '../AccountSettings.pcss';
var _React_PureComponent;
class ClinicsMemberships extends (_React_PureComponent = React.PureComponent) {
    renderLogo(clinic) {
        const { logo, name } = clinic;
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: logo,
            name: name,
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
    }
    renderAdminStatus(clinicMembership) {
        if (!clinicMembership.isAdmin) {
            return null;
        }
        const clinic = get(clinicMembership, 'clinic', {});
        const { organizationUID, name } = clinic;
        return /*#__PURE__*/ _jsx(Link, {
            to: this.context.getUrl('clinic-settings', {
                clinicSlug: getSlug(name),
                organizationUID
            }),
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.isAdmin))
        });
    }
    renderStatus(clinicMembership) {
        const message = messages.statuses[clinicMembership.membershipStatus];
        if (!message) {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.statuses[clinicMembership.membershipStatus]));
    }
    renderClinicMembership(clinicMembership) {
        const clinic = get(clinicMembership, 'clinic', {});
        return /*#__PURE__*/ _jsxs("tr", {
            children: [
                /*#__PURE__*/ _jsx("td", {
                    className: "cell--avatar",
                    children: this.renderLogo(clinic)
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: clinic.name
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: clinicMembership.hcpBusinessEmail
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: clinic.storageProvider
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: this.renderStatus(clinicMembership)
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: this.renderAdminStatus(clinicMembership)
                })
            ]
        }, clinicMembership.clinicHcpMembershipId);
    }
    render() {
        const { hcpClinicMemberships } = this.props;
        if (!hcpClinicMemberships.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.clinicsMemberships))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "section__table-container",
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: "section__table",
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                className: "section__table__head",
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("th", {
                                            colSpan: 2,
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.clinic))
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.email))
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "Storage"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.status))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                className: "section__table__body",
                                children: map(hcpClinicMemberships, (clinicMembership)=>this.renderClinicMembership(clinicMembership))
                            })
                        ]
                    })
                })
            ]
        });
    }
}
_define_property(ClinicsMemberships, "contextType", AppContext);
_define_property(ClinicsMemberships, "propTypes", {
    // Implicit props
    hcpClinicMemberships: PropTypes.arrayOf(shapes.clinicMembership),
    openDropdownId: PropTypes.string,
    // Implicit actions
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func
});
const mapStateToProps = (state)=>({
        hcpClinicMemberships: selectors.hcpClinicMemberships(state),
        openDropdownId: App.selectors.dropdown(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedClinicsMemberships = connect(mapStateToProps, mapDispatchToProps)(ClinicsMemberships);
export default ConnectedClinicsMemberships;
